const SvgTimeTravel = (props) => (
  <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
    <path
      d="M13.173 0v2.428a9.61 9.61 0 0 1 8.372 10.72c-.553 4.374-3.994 7.847-8.372 8.364v2.404c6.616-.661 11.428-6.526 10.766-13.136C23.398 5.072 18.863.565 13.173 0zm-2.406.036A11.828 11.828 0 0 0 4.355 2.68l1.72 1.779a9.623 9.623 0 0 1 4.692-2.02V.037zM2.659 4.375C1.143 6.2.24 8.425 0 10.78h2.406a9.63 9.63 0 0 1 1.973-4.687l-1.72-1.718zM.012 13.184a12.06 12.06 0 0 0 2.659 6.405l1.708-1.718a9.612 9.612 0 0 1-1.961-4.687H.012zm6.063 6.453l-1.72 1.647A12.029 12.029 0 0 0 10.767 24v-2.404a9.632 9.632 0 0 1-4.692-1.959zm6.496-13.664v6.31l5.413 3.208-.902 1.478-6.315-3.785V5.973h1.804z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default SvgTimeTravel
